import type { User } from '@core/account-types';

import type { SharingContainerApi } from './containers.types';

export enum AccessKind {
  Job = 'job',
  TalentPool = 'talent_pool',
  Role = 'role',
}

export type CandidateShareEntity = {
  sharedWith: CandidateSharedWith[];
  containers: CandidateShareContainer[];
  sharedAdminCount: number;
  sharedContainerCount: number;
  alreadyHaveAccess: CandidateShareUserGroup[];
};

export type CandidateShareContainer = Pick<
  SharingContainerApi,
  'id' | 'name' | 'candidatesCount' | 'shareUrl' | 'createdAt' | 'active'
>;

export type CandidateShareUserGroup = {
  kind: AccessKind;
  name: string;
  id: number;
  count: number;
  admins: Array<
    Pick<
      User,
      'firstName' | 'hasAvatar' | 'initials' | 'lastName' | 'photoThumbUrl' | 'roleName'
    > & { adminId: number }
  >;
};

export type CandidateSharedWith = {
  adminId: number;
  firstName: string;
  lastName: string;
  roleName: string;
  photoThumbUrl: string;
  initials: string;
  hasAvatar: boolean;
};

export type CandidateSharedWithUserRole = {
  name: string;
  description: string;
};
